import BaseModel from './BaseModel'

export default class DocumentSigningRequest extends BaseModel {
  // ... DocumentSigningRequest-specific methods or overrides ...
}
